/* eslint-disable import/order */
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { proformaExportRoute } from '@jira/router-routes__proforma-routes/src/proformaExportRoute.tsx';
import ProformaExport, { LazyProformaExport } from './ui/export/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const proformaExportRouteEntry: Route = createEntry(proformaExportRoute, () => ({
	group: 'proforma',
	layout: globalLayout,
	resources: [...getNavigationResources()],
	// eslint-disable-next-line no-restricted-syntax
	component: ProformaExport,
	forPaint: [LazyAtlassianNavigation, LazyProformaExport],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
